export const BADGE_CLASSNAMES = {
  BLUE: 'bg-blue-200 text-blue-900',
  GRAY: 'bg-grey-200 text-black',
  GREEN: 'bg-green-200 text-green-900',
  PURPLE: 'bg-purple-200 text-purple-900',
  RED: 'bg-red-200 text-red-900',
  YELLOW: 'bg-yellow-200 text-yellow-900',
};
